module.exports = __webpack_public_path__ + "img/clip.46fc686f.svg";